import BaseModel from './base-modeles/base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import Fill from '@src/slide/domain/ui-model/element-modeles/property/fill';
import { IFillProperty } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { IEffect } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { Effect } from '@src/slide/domain/ui-model/element-modeles/property/effect';
import { IBorderProperty } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import Border from '@src/slide/domain/ui-model/element-modeles/property/border';
import { IShapeModel } from './Interface/shape-model.interface';
import { ILockProperty } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import Lock from '@src/slide/domain/ui-model/element-modeles/property/lock';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IImageSize } from './property/image-size/image-size.interface';
import MultiImageSize from './property/image-size/multiply-image-size';
import { MultiplyRefreshMenu } from './property/menu-property/refresh/multiply';
import { I3DProperty, IScene3D, IShape3D } from './property/3d/property3d.interface';
import ThreeDProperty from './property/3d';
import MultiplyFrame from './property/frame/multiply';
import { IMultiplyFrameProperty } from './property/frame/multiply/index.interface';

// 多选时的model
class MultiplyModel extends BaseModel implements IMultiplyModel {
    public selectedModels: Array<IElementBaseModel>;
    private frameInstance: IMultiplyFrameProperty;
    private fillInstance: IFillProperty;
    // 效果操作实例
    private effectInstance: IEffect;
    private borderInstance: IBorderProperty;     // 边框操作实例
    private lockInstance: ILockProperty;    // 锁定纵横比操作实例
    private imageSizeInstance: IImageSize;  // 图片原始尺寸相关
    private refreshMenu: MultiplyRefreshMenu;   // 更新工具栏数据
    private property3DInstance: I3DProperty;

    public constructor(props: {
        selectedModels: Array<IElementBaseModel>,
        selectionService?: ISelectionService,
    }) {
        super(props);
        this.type = UIModelType.MULTIPLY;
        this.selectedModels = props.selectedModels;
        this.refreshMenu = new MultiplyRefreshMenu(this);
        this.refreshMenu.addRefreshItemValues();
    }

    public dispose = () => {
        this.refreshMenu.removeRefreshItemValues();
    };

    public getSelectedModels() {
        return this.selectedModels;
    }

    public getFrame(): IMultiplyFrameProperty {
        if (!this.frameInstance) {
            this.frameInstance = new MultiplyFrame(this.selectedModels);
        }
        return this.frameInstance;
    }

    public getBackgroundFill(): IFillProperty {
        if (!this.fillInstance) {
            this.fillInstance = new Fill(this);
        }
        return this.fillInstance;
    }

    /**
     * 锁定纵横比相关接口
     */
    public getLock(): ILockProperty {
        if (!this.lockInstance) {
            this.lockInstance = new Lock(this);
        }
        return this.lockInstance;
    }

    public isTextAttachment(): boolean {
        const { selectedModels } = this;
        for (let index = 0; index < selectedModels.length; index++) {
            const model = selectedModels[index];
            if (!(model as IShapeModel).isTextAttachment?.()) {
                return false;
            }
        }
        return true;
    }

    /**
     * Effect相关接口
     */
    public getEffect(): IEffect {
        if (!this.effectInstance) {
            this.effectInstance = new Effect(this);
        }
        return this.effectInstance;
    }

    public getBorder(): IBorderProperty {
        if (!this.borderInstance) {
            this.borderInstance = new Border(this);
        }
        return this.borderInstance;
    }

    /**
     * 图片原始尺寸相关
     */
    public getImageSize(): IImageSize {
        if (!this.imageSizeInstance) {
            this.imageSizeInstance = new MultiImageSize(this);
        }
        return this.imageSizeInstance;
    }

    public get3DProperty(): I3DProperty {
        if (!this.property3DInstance) {
            this.property3DInstance = new ThreeDProperty(this as any);
        }
        return this.property3DInstance;
    }

    public get scene3d(): IScene3D | undefined {
        return this.get3DProperty().getMultiplyScene3D();
    }

    public get shape3d(): IShape3D | undefined {
        return this.get3DProperty().getMultiplyShape3D();
    }
}

export default MultiplyModel;
